/**
 * Lets the phone header's overflow menu open the support chat (the floating
 * button is hidden on phones) and show its unread count.
 */
const OPEN_EVENT = 'advicelink:open-support-chat';
const UNREAD_EVENT = 'advicelink:support-chat-unread';
let lastUnread = 0;

export function requestOpenSupportChat() {
  window.dispatchEvent(new CustomEvent(OPEN_EVENT));
}

export function onOpenSupportChatRequest(handler) {
  window.addEventListener(OPEN_EVENT, handler);
  return () => window.removeEventListener(OPEN_EVENT, handler);
}

export function publishSupportChatUnread(count) {
  lastUnread = Number(count) || 0;
  window.dispatchEvent(new CustomEvent(UNREAD_EVENT, { detail: lastUnread }));
}

export function subscribeSupportChatUnread(handler) {
  handler(lastUnread);
  const listener = (event) => handler(Number(event.detail) || 0);
  window.addEventListener(UNREAD_EVENT, listener);
  return () => window.removeEventListener(UNREAD_EVENT, listener);
}
